import React from "react";

import { Participant as IParticipant, RemoteParticipant } from "twilio-video";

import useAccessControlRoom from "../hooks/useAccessControlRoom/useAccessControlRoom";
import useVideoContext from "../hooks/useVideoContext/useVideoContext";
import ParticipantInfo from "../ParticipantInfo/ParticipantInfo";
import ParticipantTracks from "../ParticipantTracks/ParticipantTracks";

interface ParticipantProps {
  participant: IParticipant;
  videoOnly?: boolean;
  enableScreenShare?: boolean;
  onClick?: () => void;
  isLocalParticipant?: boolean;
  hideParticipant?: boolean;
}

export default function Participant({
  participant,
  videoOnly,
  enableScreenShare,
  onClick,
  isLocalParticipant,
  hideParticipant,
}: ParticipantProps) {
  const { participantsAllowed } = useVideoContext();

  if (!isLocalParticipant) useAccessControlRoom(participant as RemoteParticipant);

  const hasAllowed = participantsAllowed.find((identity) => identity === participant.identity);

  if (hasAllowed || isLocalParticipant) {
    return (
      <ParticipantInfo
        participant={participant}
        onClick={onClick}
        isLocalParticipant={isLocalParticipant}
        hideParticipant={hideParticipant}
      >
        <ParticipantTracks
          participant={participant}
          videoOnly={videoOnly}
          enableScreenShare={enableScreenShare}
          isLocalParticipant={isLocalParticipant}
        />
      </ParticipantInfo>
    );
  }

  return null;
}
